// extracted by mini-css-extract-plugin
export default {"insideCountDisplay":"Z77xkcEn9SpKZ6_zLqaT"};